import React, { useEffect } from "react";
import "./banner/Banner.css";
import Banner from "./banner/Banner";
import Our_Associates from "./our_associates/Our_Associates";
import Get_in_touch from "./get-in-touch/Get_in_touch";
import Home_faq from "./faq/Home_faq";
import For_support from "../for-support/For_support";
import Counter from "./counter/Counter";
import Profcyma_Partner_Program from "./profcyma_partner_program/Profcyma_Partner_Program";
import Become_Partner from "./become_partner/Become_Partner";
import Why_Partner_With_Us from "./why_partner_with_us/Why_Partner_With_Us";
import How_To_Get_Started from "./how_to_get_started/How_To_Get_Started";
import Features from "./features/Features";
import How_it_works from "./how-it-works/How_it_works";
import Testimonials from "./testimonials/Testimonials";
import Enquire_now_btn from "./enquire-now-btn/Enquire_now_btn";

function Home() {

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <>
      <Banner />
      <Counter />
      <Our_Associates />
      <Profcyma_Partner_Program />
      <Why_Partner_With_Us/>
      <How_To_Get_Started/>
      <Become_Partner />
      <Features/>
      <How_it_works/>
      <Testimonials/>
      <Get_in_touch />
      <Home_faq />
      <For_support />
      <Enquire_now_btn />
    </>
  );
}

export default Home;
